import { CacheStrategy } from '@rammetec/data-access';
import { AUDIT_FIELD_DESCRIPTORS, AUDIT_FOREIGN_KEYS } from './_auditFields.js';
import { BUSINESS_ALLOWED_DATA_SOURCES, BUSINESS_DEFAULT_DATA_SOURCE } from './dataSourcePolicy.js';
import { WAREHOUSE_MAP } from '../types/warehouse-map.js';
import { FIELD_LIMITS } from '../validation/fieldLimits.js';
/**
 * Descriptor for warehouse-code → StockLocation map (request 0111).
 * Path: org/{orgId}/warehouse-map
 */
export const warehouseMapDescriptor = {
    name: WAREHOUSE_MAP,
    label: 'De-para de depósito',
    domain: 'stock',
    collectionPath: 'org/{orgId}/warehouse-map',
    pathPatternKeys: { orgId: 'string' },
    version: 1,
    description: 'Maps invoice warehouse text to StockLocation',
    repositoryConfig: {
        dataSource: BUSINESS_DEFAULT_DATA_SOURCE,
        cache: CacheStrategy.InMemory,
    },
    allowedDataSources: BUSINESS_ALLOWED_DATA_SOURCES,
    fields: [
        { name: 'id', label: 'ID', type: 'string', required: true },
        {
            name: 'warehouseCode',
            label: 'Código do depósito',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.CODE,
        },
        {
            name: 'stockLocationId',
            label: 'Local de estoque',
            type: 'string',
            required: true,
        },
        { name: 'lastUsedAt', label: 'Último uso', type: 'date', display: 'datetime', required: false },
        ...AUDIT_FIELD_DESCRIPTORS,
    ],
    foreignKeys: [
        ...AUDIT_FOREIGN_KEYS,
        {
            fieldName: 'stockLocationId',
            targetEntity: 'StockLocation',
            relationship: 'many-to-one',
            displayField: 'description',
        },
    ],
};
//# sourceMappingURL=warehouse-map.descriptor.js.map